/**
 * Shared recipe for form controls (text inputs and selects) so every field
 * renders with the same surface, border, and focus treatment.
 */
export const FORM_CONTROL_CLASS =
   'w-full rounded-control border border-edge bg-surface-control p-3 text-ink focus:outline-none focus:ring-2 focus:ring-green-500'
